import { FormConfig } from './types';

export const policyChange: FormConfig = {
  dialogSize: 'large',
  sections: [
    {
      columns: 2,
      heading: 'General Information',
      subheading: '',
      fields: [
        {
          id: 'momentType',
          name: 'momentType',
          label: 'Type of Release/Moment',
          type: 'api_dropdown',
          required: false,
          api: 'momentTypes'
        },
        {
          id: 'momentName',
          name: 'momentName',
          label: 'Release or Moment Name  ',
          type: 'text',
          required: true
        },

        {
          id: 'productGroups',
          name: 'productGroups',
          label: 'Product Group',
          type: 'api_dropdown',
          required: true,
          api: 'productGroups',
          dependents: ['categories']
        },
        {
          id: 'categories',
          name: 'categories',
          label: 'Category',
          type: 'api_dropdown',
          required: false,
          api: 'categories',
          dependsOn: 'productGroups'
        },
        {
          id: 'tier',
          name: 'tier',
          label: 'Tier',
          type: 'api_dropdown',
          required: true,
          api: 'tier'
        },
        {
          id: 'momentStartDate',
          name: 'momentStartDate',
          label: 'Moment Start Date',
          type: 'datepicker',
          required: true
        },
        {
          id: 'momentEndDate',
          name: 'momentEndDate',
          label: 'Moment End Date',
          type: 'datepicker',
          required: true
        },
        {
          id: 'releaseDate',
          name: 'releaseDate',
          label: 'Release Date',
          type: 'datepicker',
          required: true
        },
        {
          id: 'status',
          name: 'status',
          label: 'Status',
          type: 'api_dropdown',
          required: false,
          api: 'status'
        },
        {
          id: 'partOfEvent',
          name: 'partOfEvent',
          label: 'Part of Event',
          type: 'api_dropdown',
          required: true,
          api: 'partOfEvents',
          defaultValue: 'N/A'
        },
        {
          id: 'spacer2',
          name: 'spacer2',
          label: '',
          type: 'spacer',
          required: false,
          disabled: true
        }
      ]
    },
    {
      columns: 2,
      heading: 'Primary Contacts',
      subheading: 'minimum 1 primary contact is required',
      fields: [
        {
          id: 'prodmktmgr',
          name: 'prodmktmgr',
          label: 'Prod Marketing Manager',
          type: 'ldap',
          required: true,
          minItems: 1.0
        },
        {
          id: 'progmgr',
          name: 'progmgr',
          label: 'Program Manager',
          type: 'ldap',
          required: true,
          minItems: 1.0
        },
        {
          id: 'prodmgr',
          name: 'prodmgr',
          label: 'Product Manager',
          type: 'ldap',
          required: true,
          minItems: 1.0
        }
      ]
    },
    {
      heading: 'Overview',
      subheading: '',
      fields: [
        {
          id: 'headlineCriticalUpdate',
          name: 'headlineCriticalUpdate',
          label: 'Headline / Critical update',
          type: 'richtext',
          required: false
        },
        {
          id: 'whatWeAreLaunching',
          name: 'whatWeAreLaunching',
          label: 'What we are launching',
          type: 'richtext',
          required: false
        },
        {
          id: 'whyWeAreDoingThis',
          name: 'whyWeAreDoingThis',
          label: 'Why we are doing this',
          type: 'dropdown_richtext',
          required: true
        },
        {
          id: 'howIsItDifferent',
          name: 'howIsItDifferent',
          label: 'HOW is it different',
          type: 'richtext',
          required: true
        },
        {
          id: 'whereItWillLaunch',
          name: 'whereItWillLaunch',
          label: 'Where it will launch',
          type: 'richtext',
          required: true
        },
        {
          id: 'strategicAlignment',
          name: 'strategicAlignment',
          label: 'Strategic Alignment',
          type: 'richtext',
          required: false
        }
      ]
    }
  ]
};
